import { render, staticRenderFns } from "./BusinessUserInviteDelete.vue?vue&type=template&id=160b59b7"
import script from "./BusinessUserInviteDelete.vue?vue&type=script&lang=js"
export * from "./BusinessUserInviteDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports